import { ConditionType, TriggerType } from '@mss/mss-component-library';

// TODO: Add ENTITY_VALUE to @mss/mss-component-library
type CType = ConditionType | 'ENTITY_VALUE';

const conditionType: Record<CType, CType> = {
  EVENT_RANGE: 'EVENT_RANGE',
  STATE_CHANGE: 'STATE_CHANGE',
  STATE_CHANGE_OPERATOR: 'STATE_CHANGE_OPERATOR',
  TIME: 'TIME',
  ATTRIBUTE: 'ATTRIBUTE',
  ENTITY_VALUE: 'ENTITY_VALUE',
  CONDITIONS_AND: 'CONDITIONS_AND',
  CONDITIONS_OR: 'CONDITIONS_OR',
};

const triggerType: Record<TriggerType, TriggerType> = {
  EVENT_RANGE: 'EVENT_RANGE',
  STATE_CHANGE: 'STATE_CHANGE',
  STATE_CHANGE_OPERATOR: 'STATE_CHANGE_OPERATOR',
  TIME: 'TIME',
  TIME_PATTERN: 'TIME_PATTERN',
};

const automations = {
  types: {
    trigger: triggerType,
    condition: conditionType,
  },
};

export default automations;
